<template>
    <div class="mt-2">
        <CRow class="pl-3 pt-3 form-group">
            <CButton
                v-for="btn in productButtons"
                :key="btn.id"
                class="mr-2"
                :color="btn.id === 3 ? 'primary' : 'danger'"
                @click="btn.handler(btn.id, btn.name)"
            >{{ btn.label }}</CButton>
        </CRow>
        <CRow class="pl-3 pt-3 form-group">
            <CButton
                v-for="btn in categoriesButtons"
                :key="btn.id"
                class="mr-2"
                :color="btn.id === 3 ? 'primary' : 'danger'"
                @click="btn.handler(btn.id, btn.name)"
            >{{ btn.label }}</CButton>
        </CRow>
        <CRow class="pl-3 pt-3 form-group">
            <CButton
                v-for="btn in modifierButtons"
                :key="btn.id"
                class="mr-2"
                :color="btn.id === 3 ? 'primary' : 'danger'"
                @click="btn.handler(btn.id, btn.name)"
            >{{ btn.label }}</CButton>
        </CRow>

        <CModal
            title="Подтверждение"
            color="danger"
            :show.sync="open"
            :footer="false"
        >
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <p> {{ modalText }} </p>
                    
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="open = false"
                    >Отмена</CButton
                    >
                    <CButton
                        color="danger"
                        class="ml-3"
                        @click="handleProducts"
                    >{{ btnText }}</CButton>
                </div>
            </template>
        </CModal>
        
    </div>
</template>

<script>
    import { BUSINESS_TYPE } from '@/utils/order';

    export default {
        props: {
            type: {
                type: String,
                default: '',
            },
            id: {
                type: Number,
                default: null,
            },
        },

        data: () => ({
            modalText: '',
            btnText: '',
            open: false,
        }),

        computed: {
            productButtons() {
                return [
                    {
                        id: 1,
                        label: 'Удалить все товары',
                        handler: this.openModal,
                        name: 'product',
                        modal: {
                            text: 'Вы действительно хотите удалить все товары этого сервиса? Это действие нельзя будет отменить.',
                            btnText: 'Удалить',
                            todo: 'delete',
                        }
                    },
                    {
                        id: 2,
                        label: 'Отключить все товары',
                        handler: this.openModal,
                        name: 'product',
                        modal: {
                            text: 'Вы действительно хотите отключить все товары этого сервиса? Это действие нельзя будет отменить.',
                            btnText: 'Отключить',
                            todo: 'disable',
                        }
                    },
                    {
                        id: 3,
                        label: 'Включить все товары',
                        handler: this.openModal,
                        name: 'product',
                        modal: {
                            text: 'Вы действительно хотите включить все товары этого сервиса? Это действие нельзя будет отменить.',
                            btnText: 'Включить',
                            todo: 'enable',
                        }
                    }
                ];
            },
            categoriesButtons() {
                return [
                    {
                        id: 1,
                        label: 'Удалить все категории',
                        handler: this.openModal,
                        name: 'category',
                        modal: {
                            text: 'Вы действительно хотите удалить все категории этого сервиса? Это действие нельзя будет отменить.',
                            btnText: 'Удалить',
                            todo: 'deleteCategories',
                        }
                    },
                    {
                        id: 2,
                        label: 'Отключить все категории',
                        handler: this.openModal,
                        name: 'category',
                        modal: {
                            text: 'Вы действительно хотите отключить все категории этого сервиса? Это действие нельзя будет отменить.',
                            btnText: 'Отключить',
                            todo: 'disableCategories',
                        }
                    },
                    {
                        id: 3,
                        label: 'Включить все категории',
                        handler: this.openModal,
                        name: 'category',
                        modal: {
                            text: 'Вы действительно хотите включить все категории этого сервиса? Это действие нельзя будет отменить.',
                            btnText: 'Включить',
                            todo: 'enableCategories',
                        }
                    }
                ];
            },
            modifierButtons() {
                if (this.type !== BUSINESS_TYPE.RESTAURANT) {
                    return [];
                }
                return [
                    {
                        id: 1,
                        label: 'Удалить все модификаторы',
                        handler: this.openModal,
                        name: 'modifier',
                        modal: {
                            text: 'Вы действительно хотите удалить все модификаторы этого сервиса? Это действие нельзя будет отменить.',
                            btnText: 'Удалить',
                            todo: 'deleteModifiers',
                        }
                    },
                    {
                        id: 2,
                        label: 'Удалить все ингредиенты',
                        handler: this.openModal,
                        name: 'modifier',
                        modal: {
                            text: 'Вы действительно хотите удалить все ингредиенты этого сервиса? Это действие нельзя будет отменить.',
                            btnText: 'Удалить',
                            todo: 'deleteIngredients',
                        }
                    },
                ];
            },
        },

        methods: {
            async handleProducts() {
                const PRODUCTS = 'products';
                const CATEGORIES = 'categories';
                const run = this.todo;

                if (!run) {
                    return;
                }

                switch (run) {
                case 'delete':
                    await this.delete(PRODUCTS);
                    break;
                case 'disable':
                    await this.disable(PRODUCTS);
                    break;
                case 'enable':
                    await this.enable(PRODUCTS);
                    break;
                case 'deleteCategories':
                    await this.delete(CATEGORIES);
                    break;
                case 'disableCategories':
                    await this.disable(CATEGORIES);
                    break;
                case 'enableCategories':
                    await this.enable(CATEGORIES);
                    break;
                case 'deleteModifiers':
                    await this.delete('modifiers');
                    break;
                case 'deleteIngredients':
                    await this.delete('ingredients');
                    break;
            
                default: return;
                }

                this.todo = '';
                this.modalText = '';
                this.open = false;
            },

            async openModal(id, btnName) {
                let btn = null;

                switch (btnName) {
                case 'product':
                    btn = this.productButtons.find(btn => btn.id === id);
                    break;
                case 'category':
                    btn = this.categoriesButtons.find(btn => btn.id === id);
                    break;
                case 'modifier':
                    btn = this.modifierButtons.find(btn => btn.id === id);
                    break;
            
                default:
                    break;
                }

                if (btn) {
                    this.modalText = btn.modal.text;
                    this.todo = btn.modal.todo;
                    this.btnText = btn.modal.btnText;
                    this.open = true;
                }
            },

            async delete(route) {
                const url = `${this.getUrl(route)}/delete`;
                await this.axios.delete(url);
            },

            async disable(route) {
                const url = `${this.getUrl(route)}/disable`;
                await this.axios.post(url);
            },

            async enable(route) {
                const url = `${this.getUrl(route)}/enable`;
                await this.axios.post(url);
            },

            getUrl(route) {
                let url = '';

                switch (this.type) {
                case BUSINESS_TYPE.RESTAURANT:
                    url += '/restaurants';
                    break;
                case BUSINESS_TYPE.GROCER:
                    url += '/grocers';
                    break;
                case BUSINESS_TYPE.PHARMACY:
                    url += '/pharmacies';
                    break;
                case BUSINESS_TYPE.ASSISTANT:
                    url += '/assistants';
                    break;
                case BUSINESS_TYPE.ENTITY:
                    url += '/entities';
                    break;
            
                default: return;
                }

                if (!url || !this.id) {
                    return;
                }

                url += `/${this.id}/all`;
                url += `/${route}`;

                return url;
            },


        }
    };
</script>
